import React from "react";

const WeekDataTable = ({
    selectedMainInfoId,
    filteredData,
    handleEdit,
    handleDelete,
    setSelectedMainInfoId,
    weekName
}) => {
    if (!selectedMainInfoId) return null;

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mt-4">
                <h4 className="mb-0">
                    📊 Showing data for: <span className="text-primary">Week {weekName}</span>
                </h4>
                <button
                    className="btn btn-outline-secondary"
                    onClick={() => setSelectedMainInfoId("")}
                >
                    ⬅️ Clear
                </button>
            </div>
            <h2 className="text-center mb-4 fw-bold display-9">🏆 Team Standings</h2>

            <div className="table-responsive mt-4" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                        <tr>
                            <th>Team Place</th>
                            <th>Team Name</th>
                            <th>Total Wins</th>
                            <th>High Game</th>
                            <th>High Series</th>
                            <th>Team Rosters</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 ? (
                            <tr>
                                <td colSpan="7" className="text-center text-muted">No data found</td>
                            </tr>
                        ) : (
                            filteredData.slice(0, 5).map((team, index) => (
                                <tr key={team.id}>
                                    <td className="text-center">{index + 1}</td>
                                    <td>{team.team_name}</td>
                                    <td className="text-center">{team.year_to_date_won}</td>
                                    <td className="text-center">{team.high_game}</td>
                                    <td className="text-center">{team.high_series}</td>
                                    <td>
                                        <ul className="list-unstyled mb-0">
                                            {team?.bowler_details[0]?.bowler_details?.map((bowler, i) => (
                                                <li key={i}>
                                                    <strong>{bowler.name}</strong> (Avg: {bowler.avg})
                                                </li>
                                            ))}
                                        </ul>
                                    </td>
                                    <td>
                                        <div className="d-flex gap-3">
                                            <button className="btn btn-warning" onClick={() => handleEdit(team)}>Edit</button>
                                            <button className="btn btn-danger" onClick={() => handleDelete(team.id)}>Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default WeekDataTable;
